
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyMooringCan as ObiBuoyMooringCanElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-mooring-can.js';
 
 
 

 
 export const ObiBuoyMooringCan = createComponent({
   react: React,
   tagName: 'obi-buoy-mooring-can',
   elementClass: ObiBuoyMooringCanElement,
   events: {
     
   }
  });
 
 